import React from 'react';

import SvgIcon from './SvgIcon';

const PaperClip = props => (
    <SvgIcon {...props}>
        <g stroke="none" strokeWidth="1">
            <g transform="translate(-744.000000, -712.000000)" fillRule="nonzero">
                <g transform="translate(721.000000, 690.000000)">
                    <g transform="translate(23.000000, 22.000000)">
                        <path d="M8.52517748,12.8297214 C6.98838519,14.4148607 4.58714725,14.4148607 3.05035496,12.8297214 C1.51356267,11.244582 1.41751315,8.86687307 2.95430544,7.38080495 L7.27653375,2.92260062 C8.23702893,1.93188854 9.77382121,1.93188854 10.6382669,2.92260062 C11.5987621,3.91331269 11.5987621,5.49845201 10.6382669,6.39009288 L7.27653375,9.95665635 C6.89233568,10.3529412 6.31603857,10.3529412 5.9318405,9.95665635 C5.54764242,9.56037152 5.54764242,8.96594427 5.9318405,8.56965944 L8.621227,5.79566563 L7.18048423,4.40866873 L4.58714725,7.08359133 C3.43455303,8.27244582 3.43455303,10.1547988 4.58714725,11.244582 C5.73974146,12.3343653 7.5646823,12.4334365 8.621227,11.244582 L12.0790096,7.67801858 C13.807901,5.89473684 13.807901,3.12074303 12.0790096,1.3374613 C10.3501183,-0.445820433 7.66073182,-0.445820433 5.9318405,1.3374613 L1.60961219,5.99380805 C-0.599526721,8.27244582 -0.503477203,11.9380805 1.70566171,14.2167183 C2.85825592,15.4055728 4.29899869,16 5.83579098,16 C7.37258326,16 8.81332603,15.4055728 9.86987073,14.2167183 L14,9.95665635 L12.6553067,8.56965944 L8.52517748,12.8297214 Z" />
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

PaperClip.displayName = 'PaperClipIcon';

export default PaperClip;
